import { render, staticRenderFns } from "./SidebarOptions.vue?vue&type=template&id=553b397e&"
import script from "./SidebarOptions.vue?vue&type=script&lang=js&"
export * from "./SidebarOptions.vue?vue&type=script&lang=js&"
import style0 from "./SidebarOptions.vue?vue&type=style&index=0&id=553b397e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports